module.exports = __webpack_public_path__ + "988da3ca3f2da0a01ad19dd602124ee4.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/table_square.png
// module id = 3169
// module chunks = 0